import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="border-t border-background-800 bg-background-900/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2" aria-label="土豪漫画网首页">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-accent-400 to-primary-600 text-foreground-950 text-2xl">
                <i className="ri-vip-diamond-fill"></i>
              </span>
              <span className="font-heading text-2xl font-bold">
                <span className="text-gold-grad">土豪漫画网</span>
              </span>
            </Link>
            <p className="mt-5 max-w-md text-sm leading-7 text-foreground-400">
              土豪漫画网尊享漫画、钻石漫画、贵族漫画、豪华漫画专属内容，专属特权阅读，豪华画质，尊贵体验，为你带来无与伦比的贵族专属漫画阅读之旅。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400 transition cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400 transition cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400 transition cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400 transition cursor-pointer">
                <i className="ri-qq-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-100">内容专区</h3>
            <ul className="mt-5 space-y-3">
              {["尊享漫画", "钻石漫画", "贵族漫画", "豪华漫画"].map((item) => (
                <li key={item}>
                  <Link
                    to="/category"
                    className="text-sm text-foreground-400 hover:text-primary-300 transition"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-100">快速导航</h3>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/vip" className="text-sm text-foreground-400 hover:text-primary-300 transition">
                  会员特权
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground-400 hover:text-primary-300 transition">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-400 hover:text-primary-300 transition">
                  排行榜
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 h-px gold-line"></div>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 土豪漫画网 版权所有 · 尊享漫画 · 钻石漫画 · 贵族漫画 · 豪华漫画
          </p>
          <p className="text-xs text-foreground-500">客服邮箱：service@tuhao-manga.example.com</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;